(function(){
  if(window.tksTileLoaded){return;}
  window.tksTileLoaded=true;

  function wishList(){try{return JSON.parse(localStorage.getItem('tks_wishlist'))||[];}catch(e){return [];}}

  window.tksTileWish=function(btn){
    var list=wishList();var h=btn.dataset.handle;var idx=-1;
    for(var i=0;i<list.length;i++){if(list[i].handle===h){idx=i;break;}}
    if(idx>=0){list.splice(idx,1);btn.classList.remove('is-wished');}
    else{list.push({handle:h,title:btn.dataset.title,price:btn.dataset.price,img:btn.dataset.img,url:btn.dataset.url});btn.classList.add('is-wished');}
    localStorage.setItem('tks_wishlist',JSON.stringify(list));
    if(window.tksUpdateWishCount){window.tksUpdateWishCount();}
  };

  window.tksTileSync=function(track){
    var w=track.clientWidth;if(!w){return;}
    var i=Math.round(track.scrollLeft/w);
    var dots=track.parentNode.querySelectorAll('.tks-tile__dot');
    for(var n=0;n<dots.length;n++){dots[n].classList.toggle('on',n===i);}
  };

  function addToCart(id){
    var drawer=document.querySelector('cart-drawer');
    var body={items:[{id:parseInt(id,10),quantity:1}]};
    if(drawer&&typeof drawer.getSectionsToRender==='function'){
      try{body.sections=drawer.getSectionsToRender().map(function(s){return s.id;});body.sections_url=window.location.pathname;}catch(e){}
    }
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)?window.Shopify.routes.root:'/';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/javascript'},body:JSON.stringify(body)})
    .then(function(r){return r.json();})
    .then(function(res){
      if(res&&res.status&&res.status!==200&&res.description){alert(res.description||'Sorry, this item could not be added.');return;}
      if(drawer&&typeof drawer.renderContents==='function'){drawer.classList.remove('is-empty');drawer.renderContents(res);if(typeof drawer.open==='function'){drawer.open();}}
      else{window.location='/cart';}
    }).catch(function(){window.location='/cart';});
  }

  function openSizeModal(title,variants){
    var o=document.createElement('div');o.className='tks-szmodal';
    var box=document.createElement('div');box.className='tks-szmodal__box';
    var x=document.createElement('button');x.className='tks-szmodal__x';x.setAttribute('aria-label','Close');x.innerHTML='&times;';
    var t=document.createElement('p');t.className='tks-szmodal__t';t.textContent=title;
    var h=document.createElement('p');h.className='tks-szmodal__h';h.textContent='Choose a size';
    var opts=document.createElement('div');opts.className='tks-szmodal__opts';
    variants.forEach(function(v){var b=document.createElement('button');b.className='tks-szmodal__opt';b.textContent=v.label;b.addEventListener('click',function(){if(o.parentNode){document.body.removeChild(o);}addToCart(v.id);});opts.appendChild(b);});
    box.appendChild(x);box.appendChild(t);box.appendChild(h);box.appendChild(opts);o.appendChild(box);
    o.addEventListener('click',function(e){if(e.target===o||e.target===x){document.body.removeChild(o);}});
    document.body.appendChild(o);
  }

  window.tksTileCart=function(btn){
    if(btn.dataset.multi==='true'){
      var variants=[];try{variants=JSON.parse(btn.dataset.variants||'[]');}catch(e){variants=[];}
      if(variants.length===0){return;}
      if(variants.length===1){addToCart(variants[0].id);return;}
      openSizeModal(btn.dataset.title||'',variants);
    } else if(btn.dataset.variantId){
      addToCart(btn.dataset.variantId);
    }
  };

  function restore(root){
    var list=wishList();var handles={};for(var i=0;i<list.length;i++){handles[list[i].handle]=1;}
    var hearts=(root||document).querySelectorAll('.tks-tile__heart');
    for(var j=0;j<hearts.length;j++){if(handles[hearts[j].dataset.handle]){hearts[j].classList.add('is-wished');}}
  }
  function initDots(root){
    var tracks=(root||document).querySelectorAll('.tks-tile__track');
    for(var i=0;i<tracks.length;i++){window.tksTileSync(tracks[i]);}
  }
  document.addEventListener('DOMContentLoaded',function(){restore();initDots();});
  if(document.readyState!=='loading'){restore();initDots();}

  var obs=new MutationObserver(function(muts){
    muts.forEach(function(m){
      for(var i=0;i<m.addedNodes.length;i++){var n=m.addedNodes[i];
        if(n.nodeType===1&&(n.classList&&n.classList.contains('tks-tile')||n.querySelector&&n.querySelector('.tks-tile'))){restore(n);initDots(n);}
      }
    });
  });
  if(document.body){obs.observe(document.body,{childList:true,subtree:true});}
})();

/* TKS — in-view muted autoplay + manual pause/play for video tiles & cards */
(function(){
  if(window.tksVideoAutoplay){return;}
  window.tksVideoAutoplay=true;
  var supportsIO=('IntersectionObserver' in window);
  function tryPlay(v){try{var pr=v.play();if(pr&&pr.catch){pr.catch(function(){});}}catch(e){}}
  function btnFor(v){var m=v.closest&&v.closest('.tks-tile__media');return m?m.querySelector('.tks-tile__vbtn'):null;}
  function reflect(v){var b=btnFor(v);if(b){b.classList.toggle('is-paused',v.paused);}}
  var io=supportsIO?new IntersectionObserver(function(entries){
    for(var i=0;i<entries.length;i++){var v=entries[i].target;
      if(entries[i].isIntersecting){if(v.dataset.userPaused!=='1'){tryPlay(v);}}
      else{try{v.pause();}catch(e){}}
    }
  },{threshold:0.25}):null;
  function observe(v){
    if(!v||v.dataset.tksVid){return;}
    v.dataset.tksVid='1';v.muted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');v.loop=true;
    v.addEventListener('play',function(){reflect(v);});
    v.addEventListener('pause',function(){reflect(v);});
    if(io){io.observe(v);}else{tryPlay(v);}
  }
  function scan(root){if(!root||!root.querySelectorAll){return;}var vids=root.querySelectorAll('video.tks-autoplay');for(var i=0;i<vids.length;i++){observe(vids[i]);}}
  function init(){scan(document);}
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
  var mo=new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){var added=muts[i].addedNodes;for(var j=0;j<added.length;j++){var n=added[j];if(n.nodeType!==1){continue;}if(n.matches&&n.matches('video.tks-autoplay')){observe(n);}scan(n);}}
  });
  function startMO(){if(document.body){mo.observe(document.body,{childList:true,subtree:true});}}
  if(document.body){startMO();}else{document.addEventListener('DOMContentLoaded',startMO);}
  window.tksTileVideoToggle=function(btn,e){
    if(e){e.preventDefault();e.stopPropagation();}
    var m=btn.closest('.tks-tile__media');var v=m?m.querySelector('video.tks-autoplay'):null;
    if(!v){return;}
    if(v.paused){v.dataset.userPaused='';tryPlay(v);}else{v.pause();v.dataset.userPaused='1';}
  };
})();
